import './InsightBorderContainer.scss';

import * as React from 'react';

interface InsightsBorderContainerProps {
  children: React.ReactNode;
}

export function InsightsBorderContainer({
  children,
}: InsightsBorderContainerProps) {
  return <div className="ai-gradient-border">{children}</div>;
}
